import React, { useState, useEffect } from 'react';
import { Gift, X } from 'lucide-react';

export default function LeadCaptureFab(): React.JSX.Element | null {
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    const check = () => {
      try {
        const dismissed = localStorage.getItem('leadPopupDismissed');
        setVisible(!!dismissed);
      } catch (e) {
        setVisible(false);
      }
    };
    check();
    // Re-check when storage changes
    window.addEventListener('storage', check);
    return () => window.removeEventListener('storage', check);
  }, []);

  const reopen = () => {
    try {
      localStorage.removeItem('leadPopupDismissed');
    } catch (e) {}
    window.location.reload();
  };

  if (!visible) return null;

  return (
    <button
      onClick={reopen}
      className="fixed bottom-6 right-6 z-50 w-14 h-14 rounded-full bg-amber-500 hover:bg-amber-600 text-white shadow-lg shadow-amber-500/30 hover:shadow-xl hover:shadow-amber-500/40 transition-all duration-300 flex items-center justify-center group"
      aria-label="Get free resources"
    >
      <Gift className="w-6 h-6 group-hover:scale-110 transition-transform" />
    </button>
  );
}
